<template>
  <div class="index">
    <div class="nav">
      <p style="cursor:pointer;" @click="toIndex()">首页概览</p>
      <span>></span>
      <p class="detailTitle">{{ detailTitle }}</p>
      <!-- 异常评价明细 特殊处理 -->
      <template v-if="detailType == 'courseAbnormal' && $refs.courseAbnormal && $refs.courseAbnormal.show_detail">
        <span>></span>
        <p class="detailTitle">异常评价明细</p>
      </template>
      <div @click="goBack" class="back">返回</div>
    </div>
    <div class="header-item-title">
      <select-control
        type="detail"
        class="select_control"
        @selectOk="selectOk"
      ></select-control>
      <!-- <div class="export">
        <span>导出</span>
      </div> -->
    </div>
    <school-part :selectParmam='selectParmams' v-if="detailType == 'afterClassDetail'"></school-part>
    <tea-attaendance :selectParmam='selectParmams' v-if="detailType == 'getTeacherAttendance'"></tea-attaendance>
    <teacher-part :selectParmam='selectParmams' v-if="detailType == 'teacherActor'"></teacher-part>
    <course-start :selectParmam='selectParmams' v-if="detailType == 'courseStart'"></course-start>
    <course-classes :selectParmam='selectParmams' v-if="detailType == 'shoolStartCourse'"></course-classes>
    <courseEvaluation :selectParmam='selectParmams' :evaTab="evaTab" v-if="detailType == 'courseAbnormal'" ref="courseAbnormal"></courseEvaluation>
    <studentPart :selectParmam='selectParmams' v-if="detailType == 'studentPart'"></studentPart>
  </div>
</template>
<script>
import selectControl from "./selectControl.vue";
import schoolPart from "./table/schoolPart.vue"
import cloudMapApi from "@/api/cloudMapApi.js";
import studentPart from "./table/studentPart.vue";
import courseEvaluation from "./table/courseEvaluation.vue";
import { mapMutations, mapState } from "vuex";
export default {
  components: { selectControl ,schoolPart, courseEvaluation, studentPart,
    teaAttaendance: () => import('./table/teaAttaendance.vue'), // 师生出勤率明细表
    teacherPart: () => import('./table/teacherPart.vue'), // 教师参与情况明细表
    courseClasses: () => import('./table/courseClasses.vue'), //学校开课明细表
    courseStart: () => import('./table/courseStart.vue'), //课程开班明细表
  },
  props:["initParams","initType","evaTab"],
  data() {
    return {
      detailType:'',
      userInfo: JSON.parse(sessionStorage.userInfo || "{}"), //用户信息
      detailTitle: "学校参与情况",
      selectParmams: {},
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
    };
  },
  computed: {
    ...mapState(["isSchool"]),
  },
  created() {
    this.selectParmams = JSON.parse(JSON.stringify(this.initParams));
    this.detailTitle = this.initType.detailTitle;
    this.detailType = this.initType.detailType;
  },
  methods: {
    toIndex(){
      this.$emit("back");
    },
    goBack(){
      if(this.detailType == 'courseAbnormal' && this.$refs.courseAbnormal.show_detail){  // 课程评价统计二级页面返回特殊处理
        this.$refs.courseAbnormal.show_detail = false;
        return
      }
      this.$emit("back")
    },
    // 删除对象空值key
    removeProperty(obj) {
      Object.keys(obj).forEach((item) => {
        if (
          obj[item] === "" ||
          obj[item] === undefined ||
          obj[item] === null ||
          obj[item] === "null" ||
          (obj[item] && !obj[item].length)
        )
          delete obj[item];
      });
      return obj;
    },
    getDayDate(num) {
      let date = new Date(
        new Date(new Date().toLocaleDateString()).getTime() -
          num * 24 * 60 * 60 * 1000
      );
      return date;
    },
    selectOk(e) {
      console.log(e);
      if(this.org_type=='2'){
        this.selecTopParams = {
          pagenum: 1,
          pagesize: 10,
          topic: "校",
          orga_id: sessionStorage.orgId,
          yearly_semester: e.yearly_semester,
        };
        this.selectParmams = this.selecTopParams;
        return;
      }
      this.selecTopParams = {
        pagenum: 1,
        pagesize: 10,
        topic: "",
        yearly_semester: "2022-2023学年上学期",
      };
      if (e.prov_name) {
        this.select_name = e.prov_name;
        this.selecTopParams.topic = "省";
      } else if (e.city_name) {
        this.select_name = e.city_name;
        this.selecTopParams.topic = "市";
      } else if (e.coun_name) {
        this.select_name = e.coun_name;
        this.selecTopParams.topic = "区";
      } else if (e.orga_name) {
        this.select_name = e.orga_name;
        this.selecTopParams.topic = "校";
      } else {
        if (this.org_type != "2") {
          if (this.user_level === "99") {
            // 省级
            this.selecTopParams.topic = "省";
            this.selecTopParams.prov_code = this.userInfo.province_code;
            this.select_name = this.userInfo.province_name || "全省";
          } else if (["1", "10"].indexOf(this.user_level) > -1) {
            // 市级
            this.selecTopParams.topic = "市";
            this.selecTopParams.city_code = this.userInfo.city_code;
            this.select_name = this.userInfo.city_name || "全市";
          } else if (["2", "20", "4", "40"]) {
            // 区级
            this.selecTopParams.topic = "区";
            this.selecTopParams.coun_code = this.userInfo.area_code;
            this.select_name = this.userInfo.area_name || "全区";
          }
        }
      }
      delete e["qy"];
      if (e["prd_name"] === "全学段") {
        delete e["prd_id"];
        delete e["prd_name"];
      }
      this.removeProperty(e);
      Object.assign(this.selecTopParams, e);
      this.selectParmams = this.selecTopParams;
      console.log("筛选1", this.selectParmams);
    },
  },
};
</script>
<style lang="less">
.index {
  width: 100%;
  .nav {
    display: flex;
    font-size: 20px;
    margin-bottom: 20px;
    position: relative;
    .back{
      position: absolute;
      right: 0;
      cursor: pointer;
      color: #4991e1;
    }
    span {
      color: #888888;
      margin: 0 8px;
    }
    .detailTitle {
      color: #666666;
    }
  }
  .export-excel-wrapper{
    width:75px;
    height:35px;
    color: #4991e1;
    font-size: 14px;
    background: #ffffff;
    border: 1px solid #4991E1;
    border-radius: 4px;
    line-height: 35px;
    text-align:center;
    position:absolute;
    right: 0;
    top: -55px;
    // opacity: 0;
    cursor: pointer;
  }
  .header-item-title {
    margin-bottom: 20px;
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .export {
      // margin-left: 30%;
      width: 80px;
      color: #4991e1;
      font-size: 14px;
      background: #ffffff;
      border: 1px solid #4991e1;
      border-radius: 4px;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
  .tabs {
    display: flex;
    font-size: 20px;
    color: #333;
    p {
      margin-right: 28px;
      padding-bottom: 5px;
      cursor: pointer;
    }
    .active {
      color: #4991e1;
      border-bottom: 3px #4991e1 solid;
    }
  }
  .table {
    margin-top: 20px;
  }
}
</style>
